export default __webpack_public_path__ + "static/media/1868.eb176c4e.png";